import { render } from "./Main.vue?vue&type=template&id=1b87ece1"
import script from "./Main.vue?vue&type=script&setup=true&lang=js"
export * from "./Main.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Layouts/exhishare/Main.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b87ece1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b87ece1', __exports__)) {
    api.reload('1b87ece1', __exports__)
  }
  
  module.hot.accept("./Main.vue?vue&type=template&id=1b87ece1", () => {
    api.rerender('1b87ece1', render)
  })

}


export default __exports__